__turbopack_context__.v({
  "fade-in": "RichTextWordReveal-module-scss-module__myOaIW__fade-in",
  "reveal": "RichTextWordReveal-module-scss-module__myOaIW__reveal",
  "word": "RichTextWordReveal-module-scss-module__myOaIW__word",
});
